import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

import { formatNull, formatOverflow } from '../../Utils/GlobalUtils';

import Modal from '../../Components/Modal';
import SearchApplicants from '../../Components/SearchModals/SearchApplicants';

import Loading from '../../Components/Loading';
import LoadingLines from '../../Components/LoadingLines';
import WarningPanel from '../../Components/WarningPanel';

import headerPanel from '../../styles/HeaderPanel.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

export default function RegisterOfApplicants() {
  const location = useLocation();
  const navigate = useNavigate();

  const [applicants, setApplicants] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [reload, setReload] = React.useState(true);

  const [isSearch, setIsSearch] = React.useState(false);

  const [limitForView, setLimitForView] = React.useState(50);
  const [lastUpdateTime, setLastUpdateTime] = React.useState('');

  const token = localStorage.getItem('token');
  React.useEffect(() => {
    setLoading(true);
    axios.get(`/api/get-all-applicants?limitForView=${limitForView}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setApplicants(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
      setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
    })
  }, [reload]);
  return (
    <>
      <Modal isOpen={isSearch} closeModal={() => { window.location.hash = ''; setIsSearch(false) }}>
        <SearchApplicants />
      </Modal>

      <div className={headerPanel.panel}>
        <button className='button' onClick={() => navigate(`/add-new-applicant`, { state: { from: location.pathname + location.search + location.hash }})}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z" /></svg>
            Добавить заявителя
        </button>
        <div className={headerPanel.searchBtn} onClick={() => setIsSearch(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
            Поиск...
        </div>
      </div>
      <div className='pageWrapper'>
        <div className='tableContainer'>
          <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <div></div>
                <a className='lastUpdateWrapper'>
                    Последнее обновление таблицы: {lastUpdateTime || '--:--'} 
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{gridTemplateColumns: '70fr 30fr'}}>
                <div>Наименование или ФИО</div>
                <div>Примечание</div>
            </div>
          </div>
          {(!applicants && loading) ? <LoadingLines />
          : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
          : applicants.map((applicant) => (
              <motion.div 
                className='tableRow' 
                key={applicant.id} 
                style={{gridTemplateColumns: '70fr 30fr'}}
                onClick={() => { 
                  navigate(`/applicant/${applicant.id}`, { state: { from: location.pathname + location.search + location.hash }})
                }}
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                exit={{ scale: '97%', opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                  <div>{formatNull(applicant.name)}</div>
                  <div>{formatOverflow(formatNull(applicant.description))}</div>
              </motion.div>
          ))}
          {!warning && applicants.length > 0 && (applicants.length < applicants[0].total_count) && (
              <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                  <div></div>
                  <div>
                      <button
                          type='button'
                          className='button'
                          style={{ width: 'fit-content' }}
                          onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                          disabled={loading}
                      >
                          {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                      </button>
                  </div>
                  <div></div>
              </div>
          )}
        </div>
      </div>
    </>
  )
}